<template>
  <div class="jb" :data-list="currentListType">
    <div class="jb-head">
      <span class="jb-head-icon">
        <span class="material-symbols-outlined">{{ { MyWaiting: 'pending_actions', MyApproved: 'task_alt', Rem: 'mail', MyDeclined: 'cancel', MyCanceled: 'block' }[currentListType] || 'pending_actions' }}</span>
      </span>
      <h1 class="jb-title">{{ getJobTypeText(this.data.Filter.ListType) }}</h1>
      <span class="jb-count" v-if="data.TotalRecordCount">{{ data.TotalRecordCount }}</span>
      <button type="button" class="jb-refresh" aria-label="Yenile" @click="refreshClicked">
        <span class="material-symbols-outlined" :class="{ spinning: refreshSpin }">refresh</span>
      </button>
    </div>

    <div class="jb-content">
      <div v-if="data.Result && data.Result.length > 0" class="jb-list jb-list-fill">
        <div
          class="jb-card"
          v-for="r in data.Result"
          :key="r.Id"
          role="button"
          tabindex="0"
          @click="goToJob(r, r.Id)"
          @keyup.enter="goToJob(r, r.Id)"
        >
          <div class="jb-card-top">
            <span class="jb-tracking">{{ r.TrackingNo.Serial }}-{{ r.TrackingNo.Number }}</span>
            <span class="jb-time">{{ getFromNow(r.CreateDate) }}</span>
          </div>
          <div class="jb-card-title">{{ r.Title }}</div>
          <div v-if="isWaitingList">
            <p class="jb-card-text" v-if="r.Description">{{ r.Description }}</p>
            <div class="jb-card-due">
              <span class="material-symbols-outlined">schedule</span>
              <span>Hedeflenen Bitiş: <b>{{ r.TargetDate | date }}</b></span>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="jb-empty">
        <span class="jb-empty-icon"><span class="material-symbols-outlined">inbox</span></span>
        <p>Kayıt bulunamadı.</p>
      </div>
    </div>

    <nav class="jb-pager" aria-label="Sayfa gezinme" v-show="pageCount > 0">
      <button
        type="button"
        class="jb-pager-btn"
        aria-label="Önceki sayfa"
        :disabled="page <= 1"
        @click.prevent="
          page -= 1;
          getData();
        "
      >
        <span class="material-symbols-outlined">chevron_left</span>
      </button>

      <div class="jb-pager-center">
        <select class="jb-pager-select" v-model="page" @change="getData()" aria-label="Sayfa">
          <option v-for="(v, i) in new Array(pageCount)" :key="i" :value="i + 1">
            {{ i + 1 }}
          </option>
        </select>
        <span class="jb-pager-total">/ {{ pageCount }}</span>
      </div>

      <button
        type="button"
        class="jb-pager-btn"
        aria-label="Sonraki sayfa"
        :disabled="page >= pageCount"
        @click.prevent="
          page += 1;
          getData();
        "
      >
        <span class="material-symbols-outlined">chevron_right</span>
      </button>
    </nav>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      refreshSpin: false,
      errorMessage: null,
      loading: false,
      recordPerPage: 5,
      page: 1,
      data: {
        TotalRecordCount: 0,
        Result: [],
        predicate: "",
        Filter: {
          Predicate: "",
          Skip: 0,
          OrderBy: "TrackingNo.Number desc",
          ListType: window.location.hash?.replace("#", "") || "MyWaiting",
          Take: this.recordPerPage,
        },
      },
    };
  },
  computed: {
    hasRecord() {
      return this.data && this.data.Result && this.data.Result.length;
    },
    pageCount() {
      return (
        Math.ceil((this.data?.TotalRecordCount ?? 0) / this.recordPerPage) ?? 1
      );
    },
    currentSortField() {
      return this.data?.Filter?.OrderBy?.split(" ")[0];
    },
    currentSortDirection() {
      return this.data?.Filter?.OrderBy?.split(" ")[1] ?? "asc";
    },
    currentListType() {
      return this.data.Filter.ListType;
    },
    isWaitingList() {
      return this.currentListType == "MyWaiting" ? true : false;
    },
    currentStyle() {
      switch (this.currentListType) {
        case "MyApproved":
          return "border-success";
        case "MyDeclined":
          return "border-danger";
        case "MyCanceled":
          return "border-warning";
        default:
          return "";
      }
    },
  },
  watch: {
    // Sayfa numarası adreste (?page=) tutulur: detaydan geri dönüldüğünde kalınan sayfa açılır
    page(value) {
      if (String(this.$route.query.page || 1) === String(value)) return;
      this.$router
        .replace({
          hash: this.$route.hash,
          query: { ...this.$route.query, page: String(value) },
        })
        .catch(() => {});
    },
  },
  methods: {
    getWindowHash(){
      return window.location.hash
    },
    goToJob(type,id){
      var hash = this.getWindowHash();
      if(hash.includes('Rem')){
        this.$router.push({ name: 'RemDetail', params: { id: id } })
      }else {
        this.$router.push({ name: 'JobDetail', params: { id: id } })
      }
      console.log(type,id)
    },
    getData() {
      this.errorMessage = null;
      this.loading = true;
      var f = this.data?.Filter || {};

      if (this.filter && typeof this.filter === "object")
        Object.assign(f, this.filter);

      f.Skip = (Math.max(this.page, 1) - 1) * this.recordPerPage;
      f.Take = this.recordPerPage;
      f.Predicate = this.predicate;
      f.ListType = window.location.hash?.replace("#", "") || "MyWaiting";

      console.log("filter:", f);

      axios
        .post("/job/get", f)
        .then((x) => {
          console.log("POST Result:", x.data);
          this.data = x.data;
          if (this.page > this.pageCount) this.page = this.pageCount;
          this.$forceUpdate();
          this.$emit("onload");
        })
        .catch((x) => {
          this.$emit("onerror", "İşlem gerçekleştirilemedi: " + x);
        })
        .then(() => {
          this.loading = false;
          setTimeout(() => {
            this.refreshSpin = false;
          }, 500);
          
        });
    },
    getFromNow(date) {
      return this.$date(date).fromNow();
    },
    refreshClicked(){
      this.refreshSpin = true;
      this.data.Result = [];
      this.getData()
    }
  },
  created() {
    var queryPage = parseInt(this.$route.query.page, 10);
    if (queryPage > 0) this.page = queryPage;
    this.getData();
  },
};
</script>
<style scoped>
.jb {
  max-width: 560px;
  margin: 0 auto;
  padding: 4px 4px 0 4px;
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
  color: #092154;
}

/* Başlık */
.jb-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

/* Başlık ikonu: Dashboard'daki kartın ikon ve rengiyle aynı */
.jb-head-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: #092154;
  color: #ffffff;
  font-size: 22px;
}

.jb[data-list="MyApproved"] .jb-head-icon { background-color: #E4F6EA; color: #1E9E57; }
.jb[data-list="Rem"] .jb-head-icon { background-color: #E9F4FF; color: #097DFF; }
.jb[data-list="MyDeclined"] .jb-head-icon { background-color: #FDE8EA; color: #FF3B30; }
.jb[data-list="MyCanceled"] .jb-head-icon { background-color: #FFF1E3; color: #F37615; }

.jb-title {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  color: #092154;
}

.jb-count {
  flex-shrink: 0;
  padding: 2px 10px;
  border-radius: 100px;
  background-color: #E9EDF3;
  font-weight: 600;
  font-size: 12px;
  color: #808080;
}

.jb-refresh {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid #E6E9EE;
  border-radius: 10px;
  background-color: #ffffff;
  color: #092154;
  font-size: 22px;
}

.spinning {
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Liste */
/* Sabit sayfalama çubuğunun altında kalmaması için alt boşluk (padding: kaydırma alanına her zaman dahil olur) */
.jb-content {
  padding-bottom: calc(88px + env(safe-area-inset-bottom, 0px));
}

.jb-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.jb-card {
  box-sizing: border-box;
  padding: 14px 16px;
  overflow: hidden;
  border: 1px solid #EFEFEF;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 2px 12px rgba(9, 33, 84, 0.06);
  cursor: pointer;
}

.jb-card:active {
  background-color: #F8F8F9;
}

/* DİKEY GRID (onaylandı).
   Liste, kullanılabilir ekran yüksekliğini 5 eşit satırda paylaşır; satır en çok ~200px'e kadar uzar.
   Küçük ekranda satırların alt sınırı kartın kendi içeriğidir, yani eskisi gibi kayar. */
.jb-list-fill {
  --jb-avail: calc(100vh - 56px - env(safe-area-inset-top, 0px) - 12px - 4px - 40px - 14px - 88px - 20px);
  display: grid;
  grid-template-rows: repeat(5, minmax(min-content, 1fr));
  min-height: min(var(--jb-avail), 1048px);
}

.jb-list-fill .jb-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* DİKEY GRID SONU */

.jb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.jb-tracking {
  padding: 2px 10px;
  border-radius: 100px;
  background-color: #F1F7FF;
  font-weight: 600;
  font-size: 12px;
  color: #092154;
}

/* Takip numarası etiketi liste türüne göre tonlanır */
.jb[data-list="MyApproved"] .jb-tracking { background-color: #E4F6EA; color: #1E8E4A; }
.jb[data-list="Rem"] .jb-tracking { background-color: #E9F4FF; color: #097DFF; }
.jb[data-list="MyDeclined"] .jb-tracking { background-color: #FDE8EA; color: #C62C3A; }
.jb[data-list="MyCanceled"] .jb-tracking { background-color: #FFF1E3; color: #D9660C; }

.jb-time {
  font-weight: 400;
  font-size: 12px;
  color: #808080;
}

.jb-card-title {
  font-weight: 600;
  font-size: 15px;
  line-height: 140%;
  color: #092154;
  word-break: break-word;
}

.jb-card-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 6px 0 0 0;
  font-weight: 400;
  font-size: 13px;
  line-height: 150%;
  color: #5C6578;
}

.jb-card-due {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  font-weight: 400;
  font-size: 12px;
  color: #808080;
}

.jb-card-due b {
  font-weight: 600;
  color: #333333;
}

.jb-card-due .material-symbols-outlined {
  font-size: 18px;
}

/* Boş durum */
.jb-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 16px;
  border: 1px solid #EFEFEF;
  border-radius: 16px;
  background-color: #ffffff;
  text-align: center;
}

.jb-empty p {
  margin: 12px 0 0 0;
  font-weight: 400;
  font-size: 14px;
  color: #808080;
}

.jb-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #F1F7FF;
  color: #182F5E;
  font-size: 28px;
}

/* Sayfalama */
.jb-pager {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1020;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  box-sizing: border-box;
  padding: 10px 16px calc(env(safe-area-inset-bottom, 0px) + 10px) 16px;
  border-top: 1px solid #EFEFEF;
  background-color: #ffffff;
}

.jb-pager-btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 1px solid #E6E9EE;
  border-radius: 12px;
  background-color: #ffffff;
  color: #092154;
  font-size: 26px;
}

.jb-pager-btn:disabled {
  opacity: 0.4;
}

.jb-pager-center {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  font-size: 14px;
  color: #808080;
}

.jb-pager-select {
  height: 44px;
  min-width: 72px;
  padding: 0 12px;
  border: 1px solid #E6E9EE;
  border-radius: 10px;
  background-color: #ffffff;
  text-align: center;
  font-weight: 600;
  font-size: 15px;
  color: #092154;
}
</style>
